export default __webpack_public_path__ + "static/media/karenying-design.44cbe0dd.png";